import KTFormGroup from 'general/components/OtherKeenComponents/Forms/KTFormGroup';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSButton, {
  KTBSButtonColor,
  KTBSButtonType,
} from 'general/components/OtherKeenComponents/KTBSButton';
import KTBSDropdown, {
  KTBSDropdownDirections,
} from 'general/components/OtherKeenComponents/KTBSDropdown';
import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import Global from 'general/utils/Global';
import useOnClickOutside from 'hooks/useOnClickOutside';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const dateFilter = {
  tatCaThoiGian: 'TAT_CA_THOI_GIAN',
  homQua: 'HOM_QUA',
  homNay: 'HOM_NAY',
  tuanTruoc: 'TUAN_TRUOC',
  tuanNay: 'TUAN_NAY',
  thangTruoc: 'THANG_TRUOC',
  thangNay: 'THANG_NAY',
  baMuoiNgayGanNhat: '30_NGAY_GAN_NHAT',
  quyTruoc: 'QUY_TRUOC',
  quyNay: 'QUY_NAY',
  sauThangDauNam: 'SAU_THANG_DAU_NAM',
  sauThangCuoiNam: 'SAU_THANG_CUOI_NAM',
  namTruoc: 'NAM_TRUOC',
  namNay: 'NAM_NAY',
  thang1: 'THANG_1',
  thang2: 'THANG_2',
  thang3: 'THANG_3',
  thang4: 'THANG_4',
  thang5: 'THANG_5',
  thang6: 'THANG_6',
  thang7: 'THANG_7',
  thang8: 'THANG_8',
  thang9: 'THANG_9',
  thang10: 'THANG_10',
  thang11: 'THANG_11',
  thang12: 'THANG_12',
  quy1: 'QUY_1',
  quy2: 'QUY_2',
  quy3: 'QUY_3',
  quy4: 'QUY_4',
  tuyChon: 'TUY_CHON',
};
export const dateFilterOptions = [
  { name: 'Tất cả thời gian', value: 'TAT_CA_THOI_GIAN' },
  { name: 'Hôm qua', value: 'HOM_QUA' },
  { name: 'Hôm nay', value: 'HOM_NAY' },
  { name: 'Tuần trước', value: 'TUAN_TRUOC' },
  { name: 'Tuần này', value: 'TUAN_NAY' },
  { name: 'Tháng trước', value: 'THANG_TRUOC' },
  { name: 'Tháng này', value: 'THANG_NAY' },
  { name: '30 ngày gần nhất', value: '30_NGAY_GAN_NHAT' },
  { name: 'Quý trước', value: 'QUY_TRUOC' },
  { name: 'Quý này', value: 'QUY_NAY' },
  { name: 'Sáu tháng đầu năm', value: 'SAU_THANG_DAU_NAM' },
  { name: 'Sáu tháng cuối năm', value: 'SAU_THANG_CUOI_NAM' },
  { name: 'Năm trước', value: 'NAM_TRUOC' },
  { name: 'Năm nay', value: 'NAM_NAY' },
  { name: 'Tháng 1', value: 'THANG_1' },
  { name: 'Tháng 2', value: 'THANG_2' },
  { name: 'Tháng 3', value: 'THANG_3' },
  { name: 'Tháng 4', value: 'THANG_4' },
  { name: 'Tháng 5', value: 'THANG_5' },
  { name: 'Tháng 6', value: 'THANG_6' },
  { name: 'Tháng 7', value: 'THANG_7' },
  { name: 'Tháng 8', value: 'THANG_8' },
  { name: 'Tháng 9', value: 'THANG_9' },
  { name: 'Tháng 10', value: 'THANG_10' },
  { name: 'Tháng 11', value: 'THANG_11' },
  { name: 'Tháng 12', value: 'THANG_12' },
  { name: 'Quý 1', value: 'QUY_1' },
  { name: 'Quý 2', value: 'QUY_2' },
  { name: 'Quý 3', value: 'QUY_3' },
  { name: 'Quý 4', value: 'QUY_4' },
  { name: 'Tùy chọn', value: 'TUY_CHON' },
];
export const getDateFilterOption = (type) => {
  switch (type) {
    case dateFilter.tatCaThoiGian:
      return [moment('2024-01-01').startOf('day'), moment()];
    case dateFilter.homQua:
      return [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')];
    case dateFilter.homNay:
      return [moment(), moment()];
    case dateFilter.tuanTruoc:
      return [
        moment().subtract(1, 'weeks').startOf('isoWeek'),
        moment().subtract(1, 'weeks').endOf('isoWeek'),
      ];
    case dateFilter.tuanNay:
      return [moment().startOf('week'), moment()];
    case dateFilter.thangTruoc:
      return [
        moment().subtract(1, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month'),
      ];
    case dateFilter.thangNay:
      return [moment().startOf('month'), moment()];
    case dateFilter.baMuoiNgayGanNhat:
      return [moment().subtract(29, 'days'), moment()];
    case dateFilter.quyTruoc:
      return [
        moment().subtract(1, 'quarters').startOf('quarter'),
        moment().subtract(1, 'quarters').endOf('quarter'),
      ];
    case dateFilter.quyNay:
      return [moment().startOf('quarters'), moment()];
    case dateFilter.sauThangDauNam:
      return [moment().startOf('year'), moment().startOf('year').add(6, 'months')];
    case dateFilter.sauThangCuoiNam:
      return [moment().endOf('year').subtract(6, 'months'), moment().endOf('year')];
    case dateFilter.namTruoc:
      return [
        moment().subtract(1, 'years').startOf('year'),
        moment().subtract(1, 'years').endOf('year'),
      ];
    case dateFilter.namNay:
      return [moment().startOf('years'), moment()];
    case dateFilter.thang1:
      return [moment().month(0).startOf('month'), moment().month(0).endOf('month')];
    case dateFilter.thang2:
      return [moment().month(1).startOf('month'), moment().month(1).endOf('month')];
    case dateFilter.thang3:
      return [moment().month(2).startOf('month'), moment().month(2).endOf('month')];
    case dateFilter.thang4:
      return [moment().month(3).startOf('month'), moment().month(3).endOf('month')];
    case dateFilter.thang5:
      return [moment().month(4).startOf('month'), moment().month(4).endOf('month')];
    case dateFilter.thang6:
      return [moment().month(5).startOf('month'), moment().month(5).endOf('month')];
    case dateFilter.thang7:
      return [moment().month(6).startOf('month'), moment().month(6).endOf('month')];
    case dateFilter.thang8:
      return [moment().month(7).startOf('month'), moment().month(7).endOf('month')];
    case dateFilter.thang9:
      return [moment().month(8).startOf('month'), moment().month(8).endOf('month')];
    case dateFilter.thang10:
      return [moment().month(9).startOf('month'), moment().month(9).endOf('month')];
    case dateFilter.thang11:
      return [moment().month(10).startOf('month'), moment().month(10).endOf('month')];
    case dateFilter.thang12:
      return [moment().month(11).startOf('month'), moment().month(11).endOf('month')];
    case dateFilter.quy1:
      return [moment().quarter(1).startOf('quarter'), moment().quarter(1).endOf('quarter')];
    case dateFilter.quy2:
      return [moment().quarter(2).startOf('quarter'), moment().quarter(2).endOf('quarter')];
    case dateFilter.quy3:
      return [moment().quarter(3).startOf('quarter'), moment().quarter(3).endOf('quarter')];
    case dateFilter.quy4:
      return [moment().quarter(4).startOf('quarter'), moment().quarter(4).endOf('quarter')];
    case dateFilter.tuyChon:
      return [];
    default:
      return null;
  }
};

CustomDateRangePicker.propTypes = {
  additionalClassName: PropTypes.string,
  onPressCancel: PropTypes.func,
  onPressSave: PropTypes.func,
  alignRight: PropTypes.bool,
  initialValue: PropTypes.string,
  inlineMode: PropTypes.bool,
  toggleElementBorderRadius: PropTypes.number,
  toggleFontWeight: PropTypes.string,
  direction: PropTypes.oneOf(Object.values(KTBSDropdownDirections)),
  filterComponent: PropTypes.object,
  hasResetButton: PropTypes.bool,
  defaultValue: PropTypes.string,
};

function CustomDateRangePicker({
  additionalClassName = '',
  onPressCancel,
  onPressSave,
  alignRight = false,
  initialValue = dateFilter.baMuoiNgayGanNhat,
  inlineMode = false,
  toggleElementBorderRadius,
  toggleFontWeight,
  direction = KTBSDropdownDirections.down,
  filterComponent,
  hasResetButton = false,
  defaultValue = dateFilter.baMuoiNgayGanNhat,
}) {
  // ---- params ----
  const { t } = useTranslation();
  const ref = useRef();
  const [show, setShow] = useState(false);
  const [filter, setFilter] = useState();
  const [selectedValue, setSelectedValue] = useState(initialValue);
  const selectedName = useMemo(() => {
    return _.find(dateFilterOptions, (item) => item.value === selectedValue)?.name;
  }, [selectedValue]);
  const [startDate, setStartDate] = useState(
    filterComponent?.from ?? Global.g_filterChargeTransactionList.from
  );
  const [endDate, setEndDate] = useState(
    filterComponent?.to ?? Global.g_filterChargeTransactionList.to
  );
  const [zIndex, setZIndex] = useState('');

  useEffect(() => {
    setFilter(filterComponent);
  }, [filterComponent]);

  useEffect(() => {
    setSelectedValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    if (inlineMode) {
      setShow(true);
    }
  }, [inlineMode]);

  useEffect(() => {
    const arr = getDateFilterOption(selectedValue);
    if (_.isArray(arr) && arr.length === 2) {
      const sStartDate = arr[0].format('YYYY-MM-DD');
      const sEndDate = arr[1].format('YYYY-MM-DD');
      setStartDate(sStartDate);
      setEndDate(sEndDate);
    }
  }, [selectedValue]);

  useOnClickOutside(ref, () => {
    if (inlineMode) {
      return;
    }
    if (show) {
      setShow(false);
      handlePressSave();
    }
  });

  useEffect(() => {
    setZIndex(show ? '1021' : '');
  }, [show]);

  useEffect(() => {
    if (inlineMode && onPressSave) {
      onPressSave(selectedValue, startDate, endDate);
    }
  }, [selectedValue, startDate, endDate, inlineMode]);

  // ---- methods ----
  function handlePressCancel() {
    if (onPressCancel) {
      onPressCancel();
    }
    setShow(false);
  }

  function handlePressSave() {
    if (onPressSave) {
      onPressSave(selectedValue, startDate, endDate);
    }
  }

  function handlePressReset() {
    if (onPressSave) {
      const tmpSelectedValue = defaultValue;
      const tmpStartDate = getDateFilterOption(defaultValue)[0].format('YYYY-MM-DD');
      const tmpEndDate = getDateFilterOption(defaultValue)[1].format('YYYY-MM-DD');

      onPressSave(tmpSelectedValue, tmpStartDate, tmpEndDate);
    }
  }

  return (
    <div
      ref={ref}
      className={`position-relative ${inlineMode ? 'w-100' : ''} `}
      style={{
        zIndex: zIndex,
      }}
    >
      {!inlineMode && (
        <KTBSButton
          justifyCenter={false}
          borderRadius={toggleElementBorderRadius}
          title={selectedName}
          color={KTBSButtonColor.white}
          buttonTitleColor={AppColors.gray[800]}
          type={KTBSButtonType.default}
          additionalClassName={`border border-secondary ${additionalClassName}  dropdown-toggle justify-content-between`}
          iconElement={<i className="fa-solid fa-calendar-day bg-transparent" />}
          buttonTitleFontWeight={toggleFontWeight}
          onPress={() => {
            if (inlineMode) {
              return;
            }
            setShow(!show);
          }}
          fillTitle
        />
      )}

      {show && (
        <div
          className={`${!inlineMode
            ? `position-absolute shadow px-4 pt-4 w-auto pb-4 ${direction === 'dropup' ? 'bottom-100 mb-2' : 'top-100 mt-0'
            }`
            : 'w-100 pb-0'
            } bg-white rounded-lg`}
          style={{
            minWidth: '300px',
            right: alignRight ? 0 : '',
            zIndex: zIndex,
            ...(direction === 'dropup' && { bottom: '100%' }),
            ...(direction === 'dropdown' && { top: '100%' }),
          }}
        >
          <div>
            {/* chon khoang thoi gian */}
            <KTFormGroup
              label={!inlineMode ? UIHelper.buildFormLabel('Chọn khoảng thời gian') : <></>}
              inputName="chooseRange"
              iconElement={<i className="fa-solid fa-calendar-day bg-transparent" />}
              inputElement={
                <KTBSDropdown
                  toggleElement={
                    <button
                      className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                      type="button"
                    >
                      {selectedName}
                    </button>
                  }
                  selectedValue={selectedValue}
                  dropdownMenuItems={dateFilterOptions}
                  dropdownMenuClassName="overflow-auto w-100"
                  dropdownMenuStyle={{
                    maxHeight: '30vh',
                  }}
                  onChange={(value) => {
                    setSelectedValue(value);
                  }}
                  direction={direction}
                />
              }
            />
            {selectedValue === dateFilter.tuyChon && (
              <div className="d-flex align-items-center gap-3">
                {/* ngay bat dau */}
                <KTFormGroup
                  label={UIHelper.buildFormLabel('Ngày bắt đầu')}
                  inputName="startDate"
                  additionalClassName="mb-0 flex-grow-1"
                  inputElement={
                    <KTFormInput
                      name="startDate"
                      value={startDate}
                      onChange={(value) => {
                        if (selectedValue !== dateFilter.tuyChon) {
                          setSelectedValue(dateFilter.tuyChon);
                        }
                        setStartDate(value);
                      }}
                      type={KTFormInputType.date}
                      placeholder={'Ngày bắt đầu...'}
                      maxTime={endDate ? endDate : new Date().toISOString()}
                    />
                  }
                />

                {/* ngay ket thuc */}
                <KTFormGroup
                  label={UIHelper.buildFormLabel('Ngày kết thúc')}
                  inputName="endDate"
                  additionalClassName="mb-0 flex-grow-1"
                  inputElement={
                    <KTFormInput
                      name="endDate"
                      value={endDate}
                      onChange={(value) => {
                        if (selectedValue !== dateFilter.tuyChon) {
                          setSelectedValue(dateFilter.tuyChon);
                        }
                        setEndDate(value);
                      }}
                      type={KTFormInputType.date}
                      placeholder={'Ngày kết thúc...'}
                      minTime={startDate}
                      maxTime={new Date().toISOString()}
                    />
                  }
                />
              </div>
            )}
          </div>

          {/* actions */}
          {!inlineMode && (
            <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
              {hasResetButton && UIHelper.buildNegativeButton('Đặt lại mặc định', () => {
                handlePressReset();
                setShow(false);
              })}
              {UIHelper.buildGreenButton('Lưu lại', () => {
                handlePressSave();
                setShow(false);
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default CustomDateRangePicker;
